import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { LandingPageLayoutComponent } from './layout/landing-page-layout/landing-page-layout.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: LandingPageLayoutComponent,
    loadChildren: () => import('./pages/pages.module').then( m => m.PagesModule)
  },
  {
    path: 'registration',
    component: LandingPageLayoutComponent,
    loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationModule)
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: "enabled"
  //scrollPositionRestoration: "enabled"
};
@NgModule({
  imports: [
    RouterModule.forRoot(routes, routerOptions),
    SharedModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
